export const getInputCapabilities = () => {
  if (typeof window !== 'object') {
    return {
      hasTouchCapability: false,
      hasDesktopPointer: false,
    };
  }

  const supportsMatchMedia = typeof window.matchMedia === 'function';
  const coarsePointer = supportsMatchMedia
    ? window.matchMedia('(pointer: coarse)').matches
    : false;
  const finePointer = supportsMatchMedia
    ? window.matchMedia('(pointer: fine)').matches
    : false;
  const anyFinePointer = supportsMatchMedia
    ? window.matchMedia('(any-pointer: fine)').matches
    : false;
  const hoverPointer = supportsMatchMedia
    ? window.matchMedia('(hover: hover)').matches
    : false;
  const anyHoverPointer = supportsMatchMedia
    ? window.matchMedia('(any-hover: hover)').matches
    : false;
  const touchPoints = Number(navigator?.maxTouchPoints ?? 0) > 0;

  return {
    hasTouchCapability: coarsePointer || touchPoints,
    hasDesktopPointer:
      (finePointer || anyFinePointer) && (hoverPointer || anyHoverPointer),
  };
};

export const isTouchOnlyContext = isTouch => {
  const capabilities = getInputCapabilities();
  return (
    (isTouch || capabilities.hasTouchCapability) && !capabilities.hasDesktopPointer
  );
};
